import { SearchStock, type SearchStockProps } from "fin-web-components";
import { observer } from "mobx-react-lite";
import { globalModel } from "../../global/GlobalModel";

export type SearchStockWithCatalogProps = Omit<SearchStockProps, "stocksCatalog"> & {
  /** 清空输入（叉或删至空）时回调；依赖 fin-web-components SearchStock 的 `onCleared`（已合入 main 后生效） */
  onCleared?: () => void;
};

/** 注入 longfans GlobalModel.basicStocksCatalog，并与 MobX 联动刷新 */
export const SearchStockWithCatalog = observer(function SearchStockWithCatalog(
  props: SearchStockWithCatalogProps
) {
  return (
    <SearchStock
      {...(props as SearchStockProps)}
      stocksCatalog={globalModel.basicStocksCatalog}
    />
  );
});
